import {
  SectionName,
  GeneralSteps,
  FertilitySteps,
  GestationalSteps,
  PreservationSteps,
  MetabolicSteps,
  MenopauseSteps,
  PregnantPostpartumSteps,
  LowTestosteroneSteps,
  GenderAffirmingCareSteps
} from "#/components/carrot-card-cost-share/workflows/step-library"
import { fertilitySteps } from "#/components/carrot-card-cost-share/workflows/fertilityWorkflow"
import { adoptionSteps } from "#/components/carrot-card-cost-share/workflows/adoptionWorkflow"
import { gestationalSteps } from "#/components/carrot-card-cost-share/workflows/gestationalWorkflow"
import { preservationSteps } from "#/components/carrot-card-cost-share/workflows/preservationWorkflow"
import { metabolicSteps } from "#/components/carrot-card-cost-share/workflows/metabolicWorkflow"
import { genderAffirmingCareSteps } from "#/components/carrot-card-cost-share/workflows/genderAffirmingCareWorkflow"
import { menopauseSteps } from "#/components/carrot-card-cost-share/workflows/menopauseWorkflow"
import { lowTestosteroneSteps } from "#/components/carrot-card-cost-share/workflows/lowTestosteroneWorkflow"
import { pregnantPostpartumSteps } from "#/components/carrot-card-cost-share/workflows/pregnantPostpartumWorkflow"

export function isExcludedFromProgress(stepName: string): boolean {
  const stepsExcludedFromProgress: string[] = [
    MenopauseSteps.CARROT_CARD_CANT_BE_USED,
    PregnantPostpartumSteps.CARROT_CARD_CANT_BE_USED,
    FertilitySteps.COMPLETE_IVF_REQUIREMENTS,
    GeneralSteps.CANCEL_EXISTING_AUTH,
    GeneralSteps.APPEARS_TO_BE_QME,
    GeneralSteps.NO_FUNDS_AVAILABLE,
    GeneralSteps.BEFORE_YOU_CONTINUE,
    GeneralSteps.CARROT_CARD_READY_TO_USE,
    FertilitySteps.EXPENSE_NOT_COVERED,
    MenopauseSteps.EXPENSE_NOT_COVERED_MENOPAUSE,
    LowTestosteroneSteps.EXPENSE_NOT_COVERED_LOW_T,
    PreservationSteps.EXPENSE_NOT_COVERED_PRESERVATION,
    MetabolicSteps.EXPENSE_NOT_COVERED_METABOLIC,
    GestationalSteps.EXPENSE_NOT_COVERED_GC,
    GenderAffirmingCareSteps.EXPENSE_NOT_COVERED_GAC
  ]
  return stepsExcludedFromProgress.includes(stepName)
}

function getProgressStepsForSection(sectionName: string): string[] {
  const sectionSteps: Record<string, string[]> = {
    [SectionName.FERTILITY]: fertilitySteps.map((step) => step.name),
    [SectionName.ADOPTION]: adoptionSteps.map((step) => step.name),
    [SectionName.GESTATIONAL]: gestationalSteps.map((step) => step.name),
    [SectionName.PRESERVATION]: preservationSteps.map((step) => step.name),
    [SectionName.METABOLIC]: metabolicSteps.map((step) => step.name),
    [SectionName.GENDER_AFFIRMING_CARE]: genderAffirmingCareSteps.map((step) => step.name),
    [SectionName.MENOPAUSE]: menopauseSteps.map((step) => step.name),
    [SectionName.LOW_TESTOSTERONE]: lowTestosteroneSteps.map((step) => step.name),
    [SectionName.PREGNANT_AND_POSTPARTUM]: pregnantPostpartumSteps.map((step) => step.name),
    [SectionName.GENERAL]: fertilitySteps.map((step) => step.name) // set general to the length of fertility because it's the longest section
  }

  const steps = sectionSteps[sectionName]
  if (!steps) return []

  return [
    GeneralSteps.WHAT_IS_EXPENSE_RELATED_TO,
    ...steps,
    GeneralSteps.TOTAL_COST,
    GeneralSteps.SUBMIT_AUTHORIZATION
  ].filter((step) => !isExcludedFromProgress(step))
}

export function getTotalStepsForSection(sectionName: string): number {
  return getProgressStepsForSection(sectionName).length + 1
}

export function getActiveStepForSection(sectionName: string, currentStep: string): number {
  const indexOfActiveStep = getProgressStepsForSection(sectionName).indexOf(currentStep)
  return indexOfActiveStep >= 0 ? indexOfActiveStep + 1 : 1
}
